import React, { useEffect, useState, useRef } from 'react';
import './Navbar.css';
import { SiWebmoney } from 'react-icons/si';
import { menu } from '../../data';
import { Link, animateScroll as scroll } from 'react-scroll';
import { FaArrowUpRightFromSquare, FaBarsStaggered } from 'react-icons/fa6';
import { FaTimes } from 'react-icons/fa';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

const Navbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    if (currentScrollPos > 100) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const container = useRef(null);
  gsap.registerPlugin(useGSAP);
  useEffect(() => {
    if (visible) {
      gsap.fromTo(
        container.current,
        {
          y: -250,
          width: '100%',
        },
        {
          y: 0,
          top: 0,
          zIndex: 100,
        }
      );
    }
  }, [visible]);

  useGSAP(() => {
    const timeline = gsap.timeline();
    timeline.from('.tab__item', { opacity: 0, stagger: 0.5 });
  }, { scope: container });

  const downloadCV = () => {
    const pdfUrl = 'https://drive.google.com/file/d/1RwNW6dx-j1yAiy4axjOJRpyYaZuPvrd7/view?usp=sharing';
    window.open(pdfUrl, '_blank');
  };

  return (
    <nav className={`navbar__container ${visible ? 'visible' : ''}`} ref={container}>
      {showSidebar && (
        <div className='overlay' onClick={() => setShowSidebar(!showSidebar)}></div>
      )}
      <div className='logo__container' onClick={() => scroll.scrollToTop({ duration: 500 })}>
        <SiWebmoney />
      </div>

      <div className={`tab__group ${showSidebar ? 'show' : ''}`}>
        <div className="span icon__container close__btn" onClick={() => setShowSidebar(!showSidebar)}>
          <FaTimes />
        </div>
        {menu.map((list, index) => (
          <Link
            activeClass='active'
            className={`tab__item name ${selectedItem === list.name ? 'active' : ''}`}
            to={list.name.toLowerCase()}
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            key={index}
            onClick={() => {
              setSelectedItem(list.name);
              setShowSidebar(false); // Close the sidebar
            }}
          >
            {list.name}
          </Link>
        ))}
      </div>
      <div className="nav__buttons__group">
        <button className="btn btn__primary" onClick={downloadCV}>Dawnload CV <FaArrowUpRightFromSquare /></button>
        <FaBarsStaggered className='menu' onClick={() => setShowSidebar(!showSidebar)} />
      </div>
    </nav>
  );
};

export default Navbar;